import SubSystemType from 'SubSystemType';
import BaseServiceRequestIIS from 'BaseServiceRequestIIS';

class GetStockHeader extends BaseServiceRequestIIS {
    constructor() {
        super();
    }

    getServiceMethod() {
        return "GetStockHeader";
    }
    getSubSystem() {
        return SubSystemType.GRAPH;
    }

    getMessageName() {
        return 'StockHeader';
    }
}

export default GetStockHeader;